class ShopByColorSection extends HTMLElement {
  constructor() {
    super();
    this.controls = this.querySelector('.shop-by-color__controls');
    this.container = this.querySelector('.shop-by-color__spectrum-container');
    this.track = this.querySelector('.shop-by-color__spectrum-track');
    this.thumbIndicator = this.querySelector('.shop-by-color__thumb-indicator');
    this.tooltip = this.querySelector('.shop-by-color__tooltip');
    this.tooltipText = this.querySelector('.shop-by-color__tooltip-text');
    this.nodes = Array.from(this.querySelectorAll('.shop-by-color__swatch-node'));
    this.tabContents = Array.from(this.querySelectorAll('.color-tab-content'));

    this.currentIndex = 0;
    this.isDragging = false;

    this.onWindowMouseMove = this.onWindowMouseMove.bind(this);
    this.onWindowMouseUp = this.onWindowMouseUp.bind(this);
    this.onWindowTouchMove = this.onWindowTouchMove.bind(this);
    this.onWindowTouchEnd = this.onWindowTouchEnd.bind(this);

    if (this.nodes.length > 0) {
      this.init();
    }
  }

  init() {
    const dragArea = this.track || this.container;

    if (dragArea) {
      dragArea.addEventListener('mousedown', (e) => this.startMouseDrag(e));
      dragArea.addEventListener('touchstart', (e) => this.startTouchDrag(e), { passive: false });
    }

    this.nodes.forEach((node, index) => {
      node.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.selectIndex(index);
      });
    });

    this.selectIndex(0);
  }

  startMouseDrag(e) {
    e.preventDefault();
    this.isDragging = true;
    this.disableTransition();
    this.handleDragPosition(e.clientX);
    window.addEventListener('mousemove', this.onWindowMouseMove);
    window.addEventListener('mouseup', this.onWindowMouseUp);
  }

  onWindowMouseMove(e) {
    if (!this.isDragging) return;
    e.preventDefault();
    this.handleDragPosition(e.clientX);
  }

  onWindowMouseUp(e) {
    if (!this.isDragging) return;
    this.isDragging = false;
    window.removeEventListener('mousemove', this.onWindowMouseMove);
    window.removeEventListener('mouseup', this.onWindowMouseUp);
    this.enableTransition();
    this.selectIndex(this.currentIndex);
  }

  startTouchDrag(e) {
    if (e.touches && e.touches.length > 0) {
      e.preventDefault();
      this.isDragging = true;
      this.disableTransition();
      this.handleDragPosition(e.touches[0].clientX);
      window.addEventListener('touchmove', this.onWindowTouchMove, { passive: false });
      window.addEventListener('touchend', this.onWindowTouchEnd);
      window.addEventListener('touchcancel', this.onWindowTouchEnd);
    }
  }

  onWindowTouchMove(e) {
    if (!this.isDragging || !e.touches || e.touches.length === 0) return;
    e.preventDefault();
    this.handleDragPosition(e.touches[0].clientX);
  }

  onWindowTouchEnd(e) {
    if (!this.isDragging) return;
    this.isDragging = false;
    window.removeEventListener('touchmove', this.onWindowTouchMove);
    window.removeEventListener('touchend', this.onWindowTouchEnd);
    window.removeEventListener('touchcancel', this.onWindowTouchEnd);
    this.enableTransition();
    this.selectIndex(this.currentIndex);
  }

  disableTransition() {
    if (this.thumbIndicator) this.thumbIndicator.style.transition = 'none';
    if (this.tooltip) this.tooltip.style.transition = 'none';
  }

  enableTransition() {
    if (this.thumbIndicator) this.thumbIndicator.style.transition = '';
    if (this.tooltip) this.tooltip.style.transition = '';
  }

  handleDragPosition(clientX) {
    if (!this.track || this.nodes.length === 0) return;

    const rect = this.track.getBoundingClientRect();
    const relativeX = clientX - rect.left;
    const fraction = Math.max(0, Math.min(1, relativeX / rect.width));

    const totalSteps = this.nodes.length - 1;
    const closestIndex = totalSteps > 0 ? Math.round(fraction * totalSteps) : 0;

    // Continuous visual thumb position during active drag gesture
    const percent = fraction * 100;
    if (this.thumbIndicator) {
      this.thumbIndicator.style.left = `${percent}%`;
    }

    if (this.tooltip) {
      this.tooltip.style.left = `${percent}%`;
      this.tooltip.style.transform = `translateX(-${percent}%)`;
    }

    if (closestIndex !== this.currentIndex) {
      this.currentIndex = closestIndex;
      this.updateActiveTab(closestIndex);
    }
  }

  selectIndex(index) {
    if (index < 0 || index >= this.nodes.length) return;
    this.currentIndex = index;

    const totalSteps = this.nodes.length - 1;
    const percent = totalSteps > 0 ? (index / totalSteps) * 100 : 0;

    this.enableTransition();

    if (this.thumbIndicator) {
      this.thumbIndicator.style.left = `${percent}%`;
    }

    if (this.tooltip) {
      this.tooltip.style.left = `${percent}%`;
      this.tooltip.style.transform = `translateX(-${percent}%)`;
    }

    this.updateActiveTab(index);
  }

  updateActiveTab(index) {
    this.nodes.forEach((n, idx) => {
      n.classList.toggle('is-active', idx === index);
    });

    const activeNode = this.nodes[index];
    if (activeNode) {
      const colorTitle = activeNode.getAttribute('data-color-title') || 'Color';
      if (this.tooltipText) {
        this.tooltipText.textContent = colorTitle;
      }
    }

    this.tabContents.forEach((tab, idx) => {
      const isActive = idx === index;
      tab.classList.toggle('active', isActive);

      if (isActive) {
        setTimeout(() => {
          const carousel = tab.querySelector('carousel-component');
          if (carousel && typeof carousel.refreshSlider === 'function') {
            try {
              carousel.refreshSlider();
            } catch (e) {
              window.dispatchEvent(new Event('resize'));
            }
          }
          window.dispatchEvent(new Event('resize'));
        }, 50);
      }
    });
  }
}

if (!customElements.get('shop-by-color-section')) {
  customElements.define('shop-by-color-section', ShopByColorSection);
}
